import React from 'react';

import { Locked, Unlocked, View, ViewOff } from '@carbon/icons-react';
import { IHeaderParams, IRowNode } from 'ag-grid-community';

import IconButton from 'components/Buttons/IconButton/IconButton';

import { TmgRow } from 'app/models';

import { formatMessage } from 'utils/messages/utils';

function AggregateHeader({
  api,
  column,
  render
}: IHeaderParams & { render: (value: boolean) => JSX.Element }): JSX.Element | null {
  const field = column.getColDef().field;
  if (!field) return null;

  let areAllTrue = true;
  api.forEachNode((node: IRowNode<TmgRow>) => {
    const isGroupWithFalseAgg = node.group && !node.aggData?.[field];
    const isUngroupedLeafNode = !node.group && !node.data?.groupForLevel;

    if (isGroupWithFalseAgg || (isUngroupedLeafNode && !node.data?.[field])) {
      areAllTrue = false;
    }
  });

  return render(areAllTrue);
}

export const LockHeader = (props: IHeaderParams & { onClick: () => void }) => (
  <AggregateHeader
    {...props}
    render={(areAllRulesLocked) => (
      <IconButton
        type="button"
        testId="map-lock-all-cell"
        icon={areAllRulesLocked ? <Locked /> : <Unlocked />}
        tooltipText={formatMessage(areAllRulesLocked ? `UNLOCK_ALL_TERRITORIES` : `LOCK_ALL_TERRITORIES`)}
        onClick={props.onClick}
      />
    )}
  />
);

export const IgnoreHeader = (props: IHeaderParams & { onClick: () => void }) => (
  <AggregateHeader
    {...props}
    render={(areAllRulesIgnored) => (
      <IconButton
        type="button"
        testId="map-ignore-all-cell"
        icon={areAllRulesIgnored ? <ViewOff /> : <View />}
        tooltipText={formatMessage(areAllRulesIgnored ? `SHOW_ALL_TERRITORIES` : `HIDE_ALL_TERRITORIES`)}
        onClick={props.onClick}
      />
    )}
  />
);
